import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesDown,
  faCalendarDay,
  faCheck,
  faThumbTack,
} from "@fortawesome/pro-solid-svg-icons";
import ActivityNote from "./activity/object/ActivityNote";
import { AppointmentDate } from "@/@types/appointments.ts";
import formatDate from "@/helpers/formatDate.ts";

type ClosedStickyActivityArgs = {
  stickyType: string | null;
  setClosed: (closed: boolean) => void;
  content?: string;
  appointment?: {
    name: string;
    date: AppointmentDate;
  };
  renderActivityMeta: () => React.ReactNode;
};

export default function ClosedStickyActivity({
  stickyType,
  setClosed,
  renderActivityMeta,
  content,
  appointment,
}: ClosedStickyActivityArgs) {
  return (
    <div className="sticky-activity border-box px-3 py-2 flex flex-col gap-2 border-primary/25 bg-primary/10">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <FontAwesomeIcon
            className="text-primary"
            icon={stickyType === "regular" ? faThumbTack : faCheck}
            size="xl"
          />
          <div className="flex gap-2 *:mt-0 items-ceter flex-wrap">
            {renderActivityMeta()}
          </div>
        </div>
        <button
          type="button"
          className="sticky-button btn btn-sm p-0"
          onClick={(e) => {
            e.preventDefault();
            setClosed(false);
          }}
        >
          <FontAwesomeIcon
            icon={faAnglesDown}
            size={window.isApp ? "xl" : undefined}
          />
        </button>
      </div>
      {appointment && <AppointmentSummary appointment={appointment} />}
      {!appointment && content && (
        // The 2-line preview is already clamped via CSS and the chevron above
        // expands the post, so the "mehr" link would be dead here (#126).
        <ActivityNote
          className="line-clamp-2"
          content={content}
          showMoreButton={false}
        />
      )}
    </div>
  );
}

function AppointmentSummary({
  appointment,
}: {
  appointment: { name: string; date: AppointmentDate };
}) {
  const start = new Date(appointment.date.start);
  return (
    <div className="text-sm">
      <p className="font-medium mb-1 line-clamp-1">{appointment.name}</p>
      <div className="flex gap-2 items-center">
        <FontAwesomeIcon icon={faCalendarDay} />
        <time dateTime={start.toISOString()}>
          {formatDate(start, appointment.date.all_day ? "PP" : "PP HH:mm")}
        </time>
      </div>
    </div>
  );
}
